import { Box, SxProps, Theme, Typography } from '@mui/material';
import { baseColors } from 'utils/constants';

type Props = {
  id?: string;
  sx?: SxProps<Theme> | undefined;
  children?: React.ReactNode;
};

const CloudTitleBar = ({ sx, children }: Props) => (
  <Box
    sx={{
      width: '100%',
      mx: 'auto',
      my: 0,
      p: 1,
      textAlign: 'center',
      bgcolor: 'transparent',
      ...sx
    }}
  >
    <Typography
      variant="h4"
      sx={{
        color: baseColors.black,
        fontSize: '20px',
        fontWeight: 700,
        textAlign: 'center'
      }}
    >
      {children}
    </Typography>
  </Box>
);

export default CloudTitleBar;
